module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', [_vm._v("Add a New Lookbook to your Gallery")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-md"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "color": "#000000"
    }
  }, [_vm._v("Preparing and Checking your Sellpoint")])]) : _c('form', {
    staticClass: "gw-form"
  }, [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_name),
      expression: "gallery.gallery_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "What's the Name of your Lookbook"
    },
    domProps: {
      "value": (_vm.gallery.gallery_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_description),
      expression: "gallery.gallery_description"
    }],
    attrs: {
      "placeholder": "What's this Lookbook all about"
    },
    domProps: {
      "value": (_vm.gallery.gallery_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('h6', [_vm._v("Add a Post to "), _c('span', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v(_vm._s(_vm.gallery.gallery_name))]), _vm._v(" Lookbook")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Caption/Title this Post"
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    attrs: {
      "placeholder": "Full Post Details"
    },
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Post's media (Image/Video)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,video/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ee87a6"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addGallery
    }
  }, [_vm._v("All Done, Add Lookbook")])])]), _vm._v(" "), _c('hr')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(your lookbook is a collection or group of posts you want to keep together)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Lookbook Name"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Description"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(This would be the first post added to this lookbook)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Caption"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Details"), _c('span', {
    staticClass: "sp-form-must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1573563c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/posts/newgallery.vue
// module id = 505
// module chunks = 0